import TranslationAiTableHelper from "./translation-ai-table-helper";
import TranslationAiPricingHelper from "./translation-ai-pricing-helper";
import TranslationAiFormatHelper from "./translation-ai-format-helper";
import TranslationAiLanguageCacheHelper from "./translation-ai-language-cache-helper";


const SettingsHelpers = {
    TranslationAiTable: TranslationAiTableHelper,
    TranslationAiPricing: TranslationAiPricingHelper,
    TranslationAiFormat: TranslationAiFormatHelper,
    TranslationAiLanguageCache: TranslationAiLanguageCacheHelper,
};

export default SettingsHelpers;
